module.exports = __webpack_public_path__ + "media/images/icons/country_flags/cr-da71ea0e0e43752f1f4a93d992349b16.svg";